{
  "min": -80,
  "max": 1000,
  "R": [0, 189, 150, 150, 150, 150, 255],
  "G": [0, 169, 54, 54, 54, 54, 240],
  "B": [0, 153, 52, 52, 52, 52, 242],
  "A": [0, 32, 64, 0, 0, 64, 64],
  "I": [0, 1, 82, 92, 234, 242, 255]
}
